export default "__VITE_ASSET__DGLjitV1__"